import { ContentLayoutVariant } from '@silvertours/common-landingpages-view';

type VariantConfig = {
  includeSearch: boolean;
  includeTrustSeals: boolean;
  isMinimal: boolean;
  isPlain: boolean;
  isPromo: boolean;
  isErrorPage: boolean;
  showMarketingSlider: boolean;
  showBreadcrumbs: boolean;
};

export const resolveVariantConfig = (
  variant: ContentLayoutVariant,
): VariantConfig => {
  switch (variant.kind) {
    case 'default':
      return {
        includeSearch: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    case 'reviewsPillar':
      return {
        includeSearch: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    case 'plain':
      return {
        includeSearch: variant.includeSearch,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: true,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'promo':
      return {
        includeSearch: variant.includeSearch,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: true,
        isPromo: true,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'minimal':
      return {
        includeSearch: variant.searchMask !== 'none',
        includeTrustSeals: false,
        isMinimal: true,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'error':
      return {
        includeSearch: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: true,
        showMarketingSlider: false,
        showBreadcrumbs: false,
      };
    case 'newsletter':
      return {
        includeSearch: true,
        includeTrustSeals: true,
        isMinimal: false,
        isPlain: false,
        isPromo: false,
        isErrorPage: false,
        showMarketingSlider: true,
        showBreadcrumbs: true,
      };
    default: {
      const unhandledVariant: never = variant;
      throw new Error(`Unhandled variant: ${(unhandledVariant as any).kind}`);
    }
  }
};
